import { render } from "./ArtItems.vue?vue&type=template&id=1453e57b&scoped=true"
import script from "./ArtItems.vue?vue&type=script&lang=js"
export * from "./ArtItems.vue?vue&type=script&lang=js"

import "./ArtItems.vue?vue&type=style&index=0&id=1453e57b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1453e57b"]])

export default __exports__